




import { Component, Vue, Prop } from 'vue-property-decorator';
import { FormQuestion } from '@/interfaces/registration/FormQuestion';

@Component
export default class QuestionInputRating extends Vue {
  @Prop({ default: () => { return {}; } }) readonly formQuestion!: FormQuestion;
}
